module.exports = __webpack_public_path__ + "img/ufo-art.262c124d.webp";